import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
var SvgNoWaitlist = function SvgNoWaitlist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 187,
    viewBox: "0 0 225 187",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 5.52A3.52 3.52 0 015.52 2h177.96A3.52 3.52 0 01187 5.52V163H2V5.52z",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFFA",
    d: "M8 31h174v125H8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 74h174v39H8zM8 12.52A3.52 3.52 0 0111.52 9h166.96a3.52 3.52 0 013.52 3.52V31H8V12.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12.52A3.52 3.52 0 0111.52 9h166.96a3.52 3.52 0 013.52 3.52V31H8V12.52z",
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 43,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 43,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 55,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 55,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 49,
    width: 22,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 49,
    width: 22,
    height: 6,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 48,
    width: 10,
    height: 10,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 48,
    width: 10,
    height: 10,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 84,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 84,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 96,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 96,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 90,
    width: 22,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 90,
    width: 22,
    height: 6,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 88,
    width: 10,
    height: 10,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 88,
    width: 10,
    height: 10,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 93.5,
    r: 15.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 93.5,
    r: 15.5,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 51.5,
    r: 15.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 126,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 126,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 134.5,
    r: 15.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 137,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 137,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 131,
    width: 22,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 131,
    width: 22,
    height: 6,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 130,
    width: 10,
    height: 10,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 130,
    width: 10,
    height: 10,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 17,
    width: 28,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 17,
    width: 43,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 15,
    width: 10,
    height: 10,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 143,
    r: 44,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 143,
    r: 44,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 143,
    r: 35.415,
    fill: "#fff",
    fillOpacity: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 182.073,
    cy: 144.073,
    r: 6.439,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.073 144.073l17.171 10.732",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.306 140l.99.143a28.689 28.689 0 00-.252 5.724c.112 2.024.437 4.013.965 5.943 2.033 7.425 7.023 13.72 13.746 17.429a28.37 28.37 0 0013.745 3.527v1a29.361 29.361 0 01-14.228-3.652c-6.959-3.838-12.123-10.353-14.227-18.04a29.445 29.445 0 01-1.045-7.808c0-1.437.103-2.862.306-4.266z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.073 144.073v-30.049",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round"
  }));
};
export default SvgNoWaitlist;